import {undef} from './';

function keysFilter(keys) {
    return function keyFilter({key}) {
        return keys.includes(key);
    };
}

function noUndefFilter({value}) {
    return value !== undef;
}

function getFilteredArray(array, filter) {
    return array.filter((value, index) => {
        return filter({value, index, array});
    });
}

function getNoUndefArray(array) {
    return getFilteredArray(array, noUndefFilter);
}

function getUniqueArray(array) {
    return Array.from(new Set(array));
}

export {
    keysFilter,
    noUndefFilter,
    getFilteredArray,
    getNoUndefArray,
    getUniqueArray
};
